/* global console */
/* eslint-disable no-console */

// TODO: Use "warning" npm module like React is switching to.
export default {
  warn: function (message) {
    if (process.env.NODE_ENV !== "production") {
      if (console && console.warn) {
        console.warn(message);
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/victory-pie/node_modules/victory-core/es/victory-util/log.js
// module id = 158
// module chunks = 0